export const STICKY_MOBILE_TOOLBAR_ROW_CLASS = 'max-md:flex-row-reverse max-md:w-full max-md:min-w-0'

export const STICKY_MOBILE_TOOLBAR_SEARCH_CLASS = 'max-md:flex-1 max-md:min-w-0 max-md:w-full'
